import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faExclamation, faEye, faCopy } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import moment from 'moment';
import AceptarCancelarModal from 'components/shared/AceptarCancelarModal';
import { get, post, patch } from 'helpers/requests';
import {
  cellDateOperation,
  cellDobleRowOperation,
  cellNumOperation,
  cellOperation,
  headerDoubleRowOperation,
  headerOperation,
} from '../../helpers/tables';
import BaseTable from '../UI/BaseTable';
import DeprecatedWarningModal from '../UI/DeprecatedWarningModal';
import FilterSelect from '../shared/FilterSelect';
import {
  CANCELED_LABEL,
  CONSTRUCTION_LABEL,
  DRAFT_LABEL,
  EMITTED_LABEL,
  FRONT_DF_1,
  TIPO_INTERMEDIARIO_DIRECTO_ID,
  BASE_URL,
  API,
} from '../../CONST';
import { fdate } from '../../helpers/helpers';
import isUserHasProfile from '../../helpers/profileValidator';
import { POLICY_WRITE } from '../../helpers/profilePermission';

const NO_FILTERED_ID = -1;

const renderPolicyIsVigente = (balance) => {
  if (balance) {
    const date = moment(balance.termino_vigencia);
    const hoy = moment();
    return date.isBefore(hoy, 'date') ? 'No' : 'Sí';
  }
  return '';
};

const handleDuplicate = (item) => {
  const form = {
    base: {
      poliza_maestra_id: item.base.poliza_maestra.id,
      actividad_economica_id: item.base.actividad_economica.id,
      tipo_intermediario_id: item.base.tipo_intermediario.id,
      moneda_asegurada_id: item.base.moneda_asegurada.id,
      asegurado_id: item.base.asegurado.id,
      asegurado_alias_id: item.base.asegurado_alias ? item.base.asegurado_alias.id : null,
      producto_id: item.base.producto.id,
      tipo_cobertura_id: item.base.tipo_cobertura.id,
      tipologia_ejecucion_id: item.base.tipologia_ejecucion.id,
      tipo_institucion_id: item.base.tipo_institucion.id,
    },
    afianzado_id: item.afianzado.id,
    actividad_id: item.actividad_id,
    adjuntos_ids: item.adjuntos_ids,
    is_oportunidad: true,
  };

  if (
    item.base.tipo_intermediario.nemotecnico !== TIPO_INTERMEDIARIO_DIRECTO_ID &&
    item.base.intermediario
  ) {
    form.base.intermediario_id = item.base.intermediario.id;
  }
  // console.log('Duplicated Form:', form);
  return form;
};

const duplicateItem = async (item) => {
  try {
    const formData = handleDuplicate(item);
    const postResponse = await post(`${BASE_URL}${API.garantias}/`, formData);
    // console.log('Initial POST Response:', postResponse);
    const polizaBaseId = item.id; 
    const getResponse = await get(`${BASE_URL}${API.endosos}/?poliza_base_id=${polizaBaseId}`);
    // console.log('GET Response:', getResponse);

    const endosoFromResponse = getResponse[0];
    if (!endosoFromResponse) {
      throw new Error('No endoso data found in the GET response');
    }

    const endosoData = {
      inicio_vigencia: endosoFromResponse.inicio_vigencia,
      inicio_endoso: endosoFromResponse.inicio_endoso,
      termino_vigencia: endosoFromResponse.termino_vigencia,
      cambio_cobertura_amt: endosoFromResponse.cambio_cobertura_amt,
      cambio_comision_pct: endosoFromResponse.cambio_comision_pct,
      cambio_prima_neta_amt: endosoFromResponse.cambio_prima_neta_amt,
      poliza_base_id: postResponse.id,
      tipo_endoso_id: endosoFromResponse.tipo_endoso.id,
      glosa: endosoFromResponse.glosa,
      beneficiario_id: endosoFromResponse.beneficiario_id,
    };

    // console.log('Endoso Data for Final POST:', endosoData);
    await post(`${BASE_URL}${API.endosos}/`, endosoData);
    // const finalPostResponse = await post(`${BASE_URL}${API.endosos}/`, endosoData);
    // console.log('Final POST Response:', finalPostResponse);

    const patchData = {
      base: {
        poliza_maestra_id: postResponse.base.poliza_maestra_id,
        actividad_economica_id: postResponse.base.actividad_economica_id,
        asegurado_alias_id: postResponse.base.asegurado_alias_id,
        tipo_intermediario_id: postResponse.base.tipo_intermediario_id,
        moneda_asegurada_id: postResponse.base.moneda_asegurada_id,
        asegurado_id: postResponse.base.asegurado_id,
        producto_id: postResponse.base.producto_id,
        tipo_cobertura_id: postResponse.base.tipo_cobertura_id,
        tipologia_ejecucion_id: postResponse.base.tipologia_ejecucion_id,
        tipo_institucion_id: postResponse.base.tipo_institucion_id,
        intermediario_id: postResponse.base.intermediario ? postResponse.base.intermediario.id : null,
      },
      afianzado_id: postResponse.afianzado_id,
      actividad_id: postResponse.actividad_id,
      adjuntos_uuids: postResponse.adjuntos_uuids,
      adjuntos_ids: postResponse.adjuntos_ids,
    };

    const patchResponse = await patch(`${BASE_URL}${API.garantias}/${postResponse.id}/`, patchData);
    // console.log('PATCH Response:', patchResponse);


    return patchResponse;
  } catch (error) {
    console.error('Error in duplicateAndEndosoFlow:', error);
    throw error;
  }
};

const PolicyListTable = (props) => {
  const {
    policies,
    handleDelete,
    loading,
    onFetchData,
    onFilteredChange,
    // eslint-disable-next-line camelcase
    tipos_cobertura,
    deleteWarningOpen,
    handleDeleteWarning,
    deletePolicyId,
    refreshTableData
  } = props;
  const { listData, tiposMoneda } = policies;
  const [isCheckModalOpen, setIsCheckModalOpen] = useState(false);
  const [itemToDuplicate, setItemToDuplicate] = useState(null);
  const [isDuplicating, setIsDuplicating] = useState(false);

  const handleDuplicatePolicy = (item) => {
    setItemToDuplicate(item);
    setIsCheckModalOpen(true);
  };

  const handleConfirmDuplicate = async () => {
    setIsDuplicating(true);
    try {
      await duplicateItem(itemToDuplicate);
    } catch (error) {
      console.error('Error duplicating item:', error);
    } finally {
      setIsDuplicating(false);
      setItemToDuplicate(null);
      setIsCheckModalOpen(false);
      refreshTableData();
    }
  };

  const columns = [
    {
      Header: headerOperation('Código'),
      id: 'base__nemotecnico__icontains',
      accessor: (i) => cellOperation(i.base.nemotecnico),
      width: 115,
      fixed: 'left',
    },
    {
      Header: headerOperation('Afianzado'),
      id: 'afianzado',
      accessor: (i) => cellDobleRowOperation(i.afianzado.rut, i.afianzado.nombre),
      minWidth: 110,
      sortable: false,
      fixed: 'left',
    },
    {
      Header: headerOperation('Asegurado'),
      id: 'base__asegurado',
      accessor: (i) => cellDobleRowOperation(i.base.asegurado.rut, i.base.asegurado.nombre),
      minWidth: 110,
      sortable: false,
      fixed: 'left',
    },
    {
      Header: headerOperation('Cobertura'),
      id: 'base__tipo_cobertura__id',
      accessor: (i) => cellOperation(i.base.tipo_cobertura.descripcion, 'left'),
      Filter: (obj) => (
        <FilterSelect
          filter={obj.filter}
          defaultOption={{ label: 'Todos', value: NO_FILTERED_ID }}
          onFilterChange={obj.onChange}
          options={tipos_cobertura.map((elem) => ({ label: elem.descripcion, value: elem.id }))}
        />
      ),
      minWidth: 115,
      fixed: 'left',
    },
    {
      Header: headerOperation('Moneda'),
      id: 'base__moneda_asegurada__id',
      accessor: (i) => cellOperation(i.base.moneda_asegurada.nombre_corto),
      Filter: (obj) => (
        <FilterSelect
          onFilterChange={obj.onChange}
          filter={obj.filter}
          options={tiposMoneda.map((elem) => ({
            label: elem.value.nombre_corto,
            value: elem.value.id,
          }))}
          defaultOption={{ label: 'Todas', value: NO_FILTERED_ID }}
        />
      ),
      minWidth: 110,
    },
    {
      Header: headerDoubleRowOperation('Monto', 'Garantizado'),
      id: 'monto_garantizado',
      accessor: (i) => cellNumOperation(i.balance_cobertura_amt),
      minWidth: 100,
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Prima'),
      id: 'prima__icontains',
      accessor: (i) => cellNumOperation(i.balance_prima_neta_amt),
      minWidth: 58,
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Emisión'),
      id: 'fecha_emision',
      accessor: (i) => cellDateOperation(i.emision),
      width: 100,
    },
    {
      Header: headerOperation('Inicio Vigencia'),
      id: 'fecha_inicio_vigencia',
      accessor: (i) =>
        cellOperation(i.balance ? fdate(i.inicio_vigencia, FRONT_DF_1) : '-'),
      width: 100,
    },
    {
      Header: headerOperation('Término Vigencia'),
      id: 'fecha_termino_vigencia',
      accessor: (i) =>
        cellOperation(i.balance ? fdate(i.termino_vigencia, FRONT_DF_1) : '-'),
      width: 100,
    },
    {
      Header: headerOperation('Vigente'),
      id: 'vigentes',
      accessor: (i) => cellOperation(renderPolicyIsVigente(i.balance)),
      Filter: (obj) => (
        <FilterSelect
          onFilterChange={obj.onChange}
          filter={obj.filter}
          options={[{ label: 'Sí', value: '1' }, { label: 'No', value: '0' }]}
          defaultOption={{ label: '', value: NO_FILTERED_ID }}
        />
      ),
      width: 100,
      sortable: false,
    },
    {
      Header: headerOperation('Estado'),
      id: 'estado__icontains',
      accessor: (i) => {
        let alertClass = 'alert-success';
        if (i.estado === DRAFT_LABEL) {
          alertClass = 'alert-primary';
        } else if (i.estado === CONSTRUCTION_LABEL) {
          alertClass = 'alert-warning';
        } else if (i.estado === CANCELED_LABEL) {
          alertClass = 'alert-danger';
        }
        return cellOperation(
          <div className={`alert ${alertClass} text-center`} role="alert">
            {i.estado}
          </div>,
        );
      },
      Filter: (obj) => (
        <FilterSelect
          onFilterChange={obj.onChange}
          filter={obj.filter}
          options={[
            { label: EMITTED_LABEL, value: 'emitida' },
            { label: DRAFT_LABEL, value: 'borrador' },
            { label: CONSTRUCTION_LABEL, value: 'construccion' },
            { label: CANCELED_LABEL, value: 'cancelada' },
          ]}
          defaultOption={{ label: 'Todos', value: NO_FILTERED_ID }}
        />
      ),
      minWidth: 120,
    },
    {
      Header: headerOperation('Acciones'),
      id: 'actions',
      accessor: (i) => (
        <div
          style={{ 
            display: 'grid', 
            gridTemplateColumns: 'auto auto',
            gap: '0',
            alignItems: 'center'
          }}
          className="table-cell"
        >
          <div style={{ display: 'flex', gap: '8px' }}>
            {(!i.emitido || [DRAFT_LABEL, EMITTED_LABEL].includes(i.estado)) && (
            <>
              {deleteWarningOpen && i.id === deletePolicyId ? (
                <div className="warning-button">
                  <FontAwesomeIcon icon={faExclamation} />
                </div>
              ) : (
                isUserHasProfile(POLICY_WRITE) && (
                  <div className="action-buttons">
                    {/* Mostrar CopiarPoliza solo si es DRAFT_LABEL or EMITTED_LABEL */}
                    {[DRAFT_LABEL, EMITTED_LABEL].includes(i.estado) && (
                      <button
                        type="button"
                        className={`table-link policy ${
                          i.estado !== CONSTRUCTION_LABEL ? 'disabled' : ''
                        }`}
                        onClick={() => handleDuplicatePolicy(i)}
                        title="duplicar"
                      >
                        <FontAwesomeIcon icon={faCopy} />
                      </button>
                    )}
          
                    {/* Mostrar BorrarPoliza solo si i.estado es NOT EMITTED or DRAFT */}
                    {![EMITTED_LABEL].includes(i.estado) && (
                      <button
                        type="button"
                        className={`table-link policy ${
                          i.estado !== DRAFT_LABEL && i.estado !== CONSTRUCTION_LABEL
                            ? 'disabled'
                            : ''
                        }`}
                        onClick={() => handleDeleteWarning(i.id)}
                        title="eliminar"
                      >
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </button>
                    )}
                  </div>
                )
              )}
            </>
          )}
          </div>
          <div style={{ 
            display: 'flex',
            justifyContent: 'flex-start',
            minWidth: '32px'
          }}
          >
            <Link 
              to={`/guarantee/policies/edit/${i.id}`} 
              className="table-link policy"
              style={{ display: 'inline-flex' }}
            >
              <FontAwesomeIcon icon={isUserHasProfile(POLICY_WRITE) ? faEdit : faEye} />
            </Link>
          </div>
        </div>
      ),
      filterable: false,
      sortable: false,
      minWidth: 88,
    },
  ];

  const confirmMsg = (
    <>
      <p>¿Desea duplicar esta póliza?</p>
      <p className="inline-block-message">
        La nueva póliza se creará como borrador y deberá ser completada antes de su uso.
      </p>
    </>
  );

  return (
    <div>
      <div style={{ margin: '0 0 10px 0' }} className="policy-list-table">
        <BaseTable
          columns={columns}
          data={listData.data}
          filterable
          loading={loading}
          onFetchData={onFetchData}
          onFilteredChange={onFilteredChange}
          pages={listData.pages}
          resultCount={listData.count}
          showPagination
          hasFixedColumns
          style={{ height: '63vh' }}
        />
      </div>
      <DeprecatedWarningModal
        handleModal={handleDeleteWarning}
        handleSubmit={handleDelete}
        objectId={deletePolicyId}
        modalOpen={deleteWarningOpen}
        warningMessage="Está a un paso de eliminar una Póliza"
        confirmText="Eliminar Póliza"
      />
      <AceptarCancelarModal
        isOpen={isCheckModalOpen}
        toggle={() => setIsCheckModalOpen(false)}
        handleOk={handleConfirmDuplicate}
        handleCancel={() => setIsCheckModalOpen(false)}
        loading={isDuplicating}
        okBtnText="Aceptar"
        confirmMsg={confirmMsg}
      />
    </div>
  );
};

PolicyListTable.propTypes = {
  deletePolicyId: PropTypes.number,
  deleteWarningOpen: PropTypes.bool.isRequired,
  handleDeleteWarning: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onFetchData: PropTypes.func.isRequired,
  onFilteredChange: PropTypes.func.isRequired,
  policies: PropTypes.shape({
    listData: PropTypes.shape({
      data: PropTypes.array,
      pages: PropTypes.number,
      count: PropTypes.number,
    }),
    tiposMoneda: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.shape({
          nombre_corto: PropTypes.string,
        }),
      }),
    ),
  }).isRequired,
  tipos_cobertura: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
    }),
  ).isRequired,
  refreshTableData: PropTypes.func.isRequired,
};

PolicyListTable.defaultProps = {
  deletePolicyId: null,
};

const mapStateToProps = (state) => ({
  tipos_cobertura: state.conditioned.tipos_cobertura,
  policies: state.policies,
});

export default connect(mapStateToProps)(PolicyListTable);
